import { RootState } from 'modules/main/redux';

import { Plan } from 'modules/subscription';
import { User } from '../types';

const userData = (state: RootState): User | null => state.user.data;

const hasLoaded = (state: RootState): boolean => !!state.user.hasLoaded;

const userPlan = (state: RootState): string =>
  state.user.data?.subscription ?? Plan.Free;

const subscriptionEndsAt = (state: RootState): string | null =>
  state.user.data?.subscriptionEndsAt ?? null;

const featureFlags = (state: RootState): Record<string, boolean> =>
  state.user.data?.featureFlags ?? {};

export const UserSelectors = {
  userData,
  hasLoaded,
  userPlan,
  subscriptionEndsAt,
  featureFlags,
};
